import { useGetApiData } from "shared/datalayer";
import { ApiUrlType } from "shared/datalayer/type";
import { getErrorMessage } from "shared/utils/network";
import { errorToast } from "shared/utils/toastNotification";
import { ApiLoggedInUser } from "./types";

const sessionRefreshApi = "session/refresh" as ApiUrlType;
export const sessionRefreshApiKey = sessionRefreshApi;
export function useGetAuthorities({ successHandler }: { successHandler: (data: ApiLoggedInUser) => void }) {
  return useGetApiData<ApiLoggedInUser>(
    sessionRefreshApi,
    {},
    {
      onSuccess: data => successHandler(data),
      onError: err => errorToast(getErrorMessage(err))
    }
  );
}
